// extracted by mini-css-extract-plugin
module.exports = {"CategoryDetailsEdit":"CategoryDetailsEdit_CategoryDetailsEdit__fzJ2S","formInputWrapper":"CategoryDetailsEdit_formInputWrapper__2jvK3"};